export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/util/eventConsts.js
// module id = 1184
// module chunks = 22